import React from "react";

/**
 * Vorion brand logo — gold V monogram + "Turning data into revenue" tagline.
 * Renders an <img> from /brand/vorion-logo.png so swapping the asset later
 * is a one-file change.
 *
 * Variants:
 *   - "mark"     → just the monogram, sized via `size` (default 32px). Use in
 *                  tight spaces / sidebars / nav.
 *   - "lockup"   → monogram + "VORION" wordmark side by side. Use in headers.
 */
export default function VorionLogo({
  variant = "mark",
  size = 32,
  className = "",
  showWordmark = false,
  testid = "vorion-logo",
}) {
  const showText = variant === "lockup" || showWordmark;
  return (
    <span
      className={`inline-flex items-center gap-2 ${className}`}
      data-testid={testid}
    >
      <img
        src="/brand/vorion-logo.png"
        alt="Vorion"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        className="select-none shrink-0"
        draggable={false}
      />
      {showText && (
        <span className="text-sm font-bold text-white tracking-wide">
          Vorion
        </span>
      )}
    </span>
  );
}
